export default __webpack_public_path__ + "static/balance-transfer-carousel-0ea71959ff2cfa133e7adb0423213797.webp";